import { useEffect, useState } from 'react';
import {
  useMatch,
  Outlet,
  NavLink,
  useParams,
  generatePath,
} from 'react-router-dom';
import { Account, IconRight, Tabs } from '@ui/src';
import { useAppSelector } from '@store';
import { OverviewStatementsTypes } from './types';

import cn from './styles.module.css';

const StatementsList = ({
  matchPath,
  cardsRoute,
  routes,
  accounts,
  cards,
  cardsEnabled,
  balances,
  type,
}: OverviewStatementsTypes) => {
  const [currentAccount, setCurrentAccount] = useState<Account>();

  const { customerId } = useParams();

  const { accountId } = useAppSelector((state) => state.customerStatements);

  const match = useMatch(matchPath);

  useEffect(() => {
    if (accountId) {
      setCurrentAccount(accounts?.find((item) => item.id === accountId));
    }
  }, [accounts, accountId]);

  return (
    <>
      {type !== 'COMPANY_OFFICIAL' && (
        <>
          <div className={cn.overviewStatementsTitle}>
            Statement of account
            <NavLink
              className={`${cn.overviewStatementsTitleLink} ${
                !accountId ? cn.overviewStatementsTitleLinkDisabled : ''
              }`}
              to={
                match
                  ? `/accounts/statements?account=${currentAccount?.fullNumber}`
                  : generatePath(cardsRoute, { customerId })
              }
            >
              View all
              <IconRight />
            </NavLink>
          </div>
          {cardsEnabled && (
            <div className={cn.overviewStatementsTabs}>
              <Tabs
                tabs={[
                  {
                    name: 'Account transactions',
                    path: generatePath(routes.transationRoute, {
                      customerId,
                    }),
                  },
                  {
                    name: 'Card transactions',
                    path: generatePath(routes.cardsRoute, {
                      customerId,
                    }),
                  },
                ]}
                enableRouting
              />
            </div>
          )}
        </>
      )}
      <Outlet context={{ accounts, cards, currentAccount, balances }} />
    </>
  );
};

export default StatementsList;
